export default "__VITE_ASSET__b240267c__"